import { getQuery } from 'utilities/query';
import templateUrl from './usage-data.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    dialogTitle: '@',
    locked: '<',
    showGuidance: '<',
    usages: '<',
    showHeader: '<',
    showActionButtons: '<',
    usageDataChanged: '&',
    missingMessage: '@'
  },
  controller: class UsageDataFormComponent {
    constructor(EventEmitter, UsageDataService) {
      'ngInject';

      Object.assign(this, {
        EventEmitter,
        UsageDataService
      });
    }

    $onInit() {
      this.Q4Value = 0;
      this.getQ4Value();
      this.query = getQuery();
      this.limitOptions = [5, 10, 25, 50];

      if (!(this.dialogTitle && this.dialogTitle.length)) {
        this.dialogTitle = 'Number of Units Shipped (Shipping Data)';
      }
    }

    getQ4Value() {
      const promise = this.UsageDataService
      .getQ4Value(this.usages[0].ProductId, (this.usages[0].UsageYear - 1));

      return promise.then((result) => {
        this.Q4Value = result.data;
      });
    }

    showWarning(value1, value2) {
      if (((value1 - value2) / value2) > 1) {
        return true;
      } else if (((value2 - value1) / value1) > 1) {
        return true;
      }
      return false;
    }

    showWarningMessage() {
      const errors = document.getElementsByClassName('error-icon');
      if (errors.length > 0) {
        if (errors.length === 1 && errors[0].classList[1] === 'warning-message') {
          return false;
        }
        return true;
      }
      return false;
    }

    calculateUsageTotal(usage) {
      return +usage.Q1 + +usage.Q2 + +usage.Q3 + +usage.Q4;
    }

    onSubmit() {
      this.usageDataChanged(
        this.EventEmitter({
          usages: this.usages
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/usage-data/usage-data.component.js